import { RouteConfig } from 'packages/route'
import { lazy } from 'react'

export const getRoutes: () => RouteConfig[] = () => [
  {
    path: 'admin/students',
    name: 'AdminStudents',
    getTitle: () => '学生管理',
    component: lazy(() =>
      import('./pages/List').then((m) => ({
        default: m.AdminStudents,
      }))
    ),
    subRoutes: [
      {
        path: 'normal',
        getTitle: () => '在校学生',
        component: lazy(() =>
          import('./pages/List/Normal').then((m) => ({
            default: m.NormalStudentList,
          }))
        ),
      },
    ],
  },
  {
    path: 'admin/students/fields-manager',
    name: 'AdminStudentsFieldsManager',
    getTitle: () => '字段设置',
    component: lazy(() =>
      import('./pages/FieldManagement').then((m) => ({
        default: m.StudentsFieldManagement,
      }))
    ),
  },
]
